module.exports = __webpack_public_path__ + "img/close_black.751facd6.svg";